export default __webpack_public_path__ + "static/media/project-img-9.88f6b558.png";